import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ShowIfHasFeatureFlagDirective } from './has-feature-flag/has-feature-flag.directive';
import { ShowIfHasNotFeatureFlagDirective } from './has-not-feature-flag/has-not-feature-flag.directive';
import { ShowIfHasNotPermissionDirective } from './has-not-permission/has-not-permission.directive';
import { ImageLoadDirective } from './image-load/image-load.directive';
import { MaskDirective } from './mask/mask.directive';
import { TooltipWhenTruncatedDirective } from './tooltip-when-truncated/tooltip-when-truncated.directive';


@NgModule({
  declarations: [
    TooltipWhenTruncatedDirective,
    ShowIfHasNotPermissionDirective,
    ShowIfHasFeatureFlagDirective,
    ShowIfHasNotFeatureFlagDirective,
    ImageLoadDirective,
    MaskDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    TooltipWhenTruncatedDirective,
    ShowIfHasNotPermissionDirective,
    ShowIfHasFeatureFlagDirective,
    ShowIfHasNotFeatureFlagDirective,
    ImageLoadDirective,
    MaskDirective
  ]
})
export class DirectivesModule { }
